function lockScreen(duration = 1000) {
    const bodyScreen = document.querySelector('.body-screen');
    if (!bodyScreen) return;
    bodyScreen.classList.add('lock-screen');
    setTimeout(() => {
        bodyScreen.classList.remove('lock-screen');
    }, duration);
}



gsap.registerPlugin(ScrollTrigger);
let mm = gsap.matchMedia(); // or just gsap.matchMedia
let pinGroups = gsap.utils.toArray(".pin-group");
let pinGroupsImage = gsap.utils.toArray(".image_fade_up");

function createSafeScrollTween(target, vars) {
    const resolvedTarget = typeof target === 'string' ? gsap.utils.toArray(target) : target;
    if (!resolvedTarget || (Array.isArray(resolvedTarget) && !resolvedTarget.length)) return;

    const resolvedVars = { ...vars };
    const scrollTriggerConfig = vars && vars.scrollTrigger ? vars.scrollTrigger : null;

    if (scrollTriggerConfig) {
        const resolvedScrollTrigger = { ...scrollTriggerConfig };

        if (typeof scrollTriggerConfig.trigger === 'string') {
            const triggerElement = document.querySelector(scrollTriggerConfig.trigger);
            if (!triggerElement) return;
            resolvedScrollTrigger.trigger = triggerElement;
        }

        if (typeof scrollTriggerConfig.pin === 'string') {
            const pinElement = document.querySelector(scrollTriggerConfig.pin);
            if (!pinElement) return;
            resolvedScrollTrigger.pin = pinElement;
        }

        resolvedVars.scrollTrigger = resolvedScrollTrigger;
    }

    gsap.to(resolvedTarget, resolvedVars);
}

// gsap.to('.HIW_LI_BG_1', {
//     // x: 700,
//     duration: 3,
//     scrollTrigger: {
//       trigger: '.HIW_LI_BG_2',
//       start: 'top 90%',
//       end: 'top 40%',
//       toggleClass: 'active',
//       pin: '.HIW_LI_BG_1',
//       pinSpacing: true,
//       scrub: 1,
//       markers: true,
//       onUpdate: (self) => {
//         let progress = self.progress;
//         gsap.to('.opacity_s', { opacity: progress });
//       },
//     },
//   }); 

mm.add("(min-width: 540px)", () => {
    if (document.querySelector('.trigger_section_slider') && document.querySelector('.pin-sensor-slider')) {
        createSafeScrollTween('.pin-sensor-slider', {
            // x: 700,
            duration: 3,
            scrollTrigger: {
                trigger: '.trigger_section_slider',
                start: 'top 100%',
                // end: 'top 30%',
                // toggleClass: 'active',
                pin: '.pin-sensor-slider',
                pinSpacing: true,
                scrub: 1,
                // markers: true,
                onEnter: () => lockScreen(),
                onEnterBack: () => console.log('onEnterBack'),
                onUpdate: (self) => {
                    let progress = self.progress;
                    gsap.to('.opacity_s', { opacity: progress });
                    if (progress > 0 && progress < 1) {
                        document.querySelector('.pin-sensor-slider')?.classList.add('active-sensor');
                    } else {
                        document.querySelector('.pin-sensor-slider')?.classList.remove('active-sensor');
                    }
                },
            },
        });
    }
    createSafeScrollTween('.pin-group-1', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-2',
            start: 'top 94%',
            end: 'top 15%',
            pin: '.pin-group-1',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_1', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-1')?.classList.add('active-1');
                } else {
                    document.querySelector('.pin-group-1')?.classList.remove('active-1');
                }
            },
        },
    });
    createSafeScrollTween('.pin-group-2', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-3',
            start: 'top 100%',
            end: 'top 15%',
            pin: '.pin-group-2',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_2', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-2')?.classList.add('active-2');
                } else {
                    document.querySelector('.pin-group-2')?.classList.remove('active-2');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-3', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-46',
            start: 'top 94%',
            end: 'top 15%',
            toggleClass: 'active-3',
            pin: '.pin-group-3',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_3', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-3')?.classList.add('active-3');
                } else {
                    document.querySelector('.pin-group-3')?.classList.remove('active-3');
                }
            },
        },
    });


    //   {% comment %} Animation  tarining membership {% endcomment %}

    createSafeScrollTween('.pin-group-4', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-5',
            start: 'top 94%',
            end: 'top 15%',
            pin: '.pin-group-4',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_4', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-4')?.classList.add('active-4');
                } else {
                    document.querySelector('.pin-group-4')?.classList.remove('active-4');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-5', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-6',
            start: 'top 100%',
            end: 'top 15%',
            pin: '.pin-group-5',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_5', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-5')?.classList.add('active-5');
                } else {
                    document.querySelector('.pin-group-5')?.classList.remove('active-5');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-6', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-7',
            start: 'top 94%',
            end: 'top 15%',
            toggleClass: 'active-3',
            pin: '.pin-group-6',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_6', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-6')?.classList.add('active-6');
                } else {
                    document.querySelector('.pin-group-6')?.classList.remove('active-6');
                }
            },
        },
    });


    createSafeScrollTween('.pin-group-7', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-8',
            start: 'top 94%',
            end: 'top 15%',
            toggleClass: 'active-3',
            pin: '.pin-group-7',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_7', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-7')?.classList.add('active-7');
                } else {
                    document.querySelector('.pin-group-7')?.classList.remove('active-7');
                }
            },
        },
    });
});



// ============================ 540px ============================
mm.add("(max-width: 540px)", () => {
    if (document.querySelector('.trigger_section_slider') && document.querySelector('.pin-sensor-slider')) {
        createSafeScrollTween('.pin-sensor-slider', {
            // x: 700,
            duration: 3,
            scrollTrigger: {
                trigger: '.trigger_section_slider',
                start: 'top 95%',
                // end: 'top 20%',
                toggleClass: 'active',
                pin: '.pin-sensor-slider',
                pinSpacing: true,
                scrub: 1,
                //  markers: true,
                onEnter: () => lockScreen(),
                onUpdate: (self) => {
                    let progress = self.progress;
                    gsap.to('.opacity_s', { opacity: progress });
                },
            },
        });
    }
    createSafeScrollTween('.pin-group-1', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-2',
            start: 'top 82%',
            end: 'top 20%',
            pin: '.pin-group-1',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_1', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-1')?.classList.add('active-1');
                } else {
                    document.querySelector('.pin-group-1')?.classList.remove('active-1');
                }
            },
        },
    });
    createSafeScrollTween('.pin-group-2', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-3',
            start: 'top 90%',
            end: 'top 25%',
            pin: '.pin-group-2',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_2', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-2')?.classList.add('active-2');
                } else {
                    document.querySelector('.pin-group-2')?.classList.remove('active-2');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-3', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-46',
            start: 'top 82%',
            end: 'top 20%',
            toggleClass: 'active-3',
            pin: '.pin-group-3',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_3', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-3')?.classList.add('active-3');
                } else {
                    document.querySelector('.pin-group-3')?.classList.remove('active-3');
                }
            },
        },
    });


    //   {% comment %} Animation  tarining membership {% endcomment %}

    createSafeScrollTween('.pin-group-4', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-5',
            start: 'top 82%',
            end: 'top 18%',
            pin: '.pin-group-4',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_4', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-4')?.classList.add('active-4');
                } else {
                    document.querySelector('.pin-group-4')?.classList.remove('active-4');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-5', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-6',
            start: 'top 82%',
            end: 'top 18%',
            pin: '.pin-group-5',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_5', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-5')?.classList.add('active-5');
                } else {
                    document.querySelector('.pin-group-5')?.classList.remove('active-5');
                }
            },
        },
    });

    createSafeScrollTween('.pin-group-6', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-7',
            start: 'top 82%',
            end: 'top 18%',
            toggleClass: 'active-3',
            pin: '.pin-group-6',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_6', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-6')?.classList.add('active-6');
                } else {
                    document.querySelector('.pin-group-6')?.classList.remove('active-6');
                }
            },
        },
    });


    createSafeScrollTween('.pin-group-7', {
        // x: 700,
        duration: 3,
        scrollTrigger: {
            trigger: '.pin-group-8',
            start: 'top 82%',
            end: 'top 18%',
            toggleClass: 'active-3',
            pin: '.pin-group-7',
            pinSpacing: true,
            scrub: 1,
            // markers: true,
            onUpdate: (self) => {
                let progress = self.progress;
                gsap.to('.opacity_s_7', { opacity: progress });
                if (progress > 0 && progress < 1) {
                    document.querySelector('.pin-group-7')?.classList.add('active-7');
                } else {
                    document.querySelector('.pin-group-7')?.classList.remove('active-7');
                }
            },
        },
    });
});



//   {% comment %} Last sections {% endcomment %}
// pinGroups.forEach((pingroup) => {
//     ScrollTrigger.create({
//       trigger: pingroup,
//       start: 'top 15%',
//     //   {% comment %} end: 'top 40%', {% endcomment %}
//        toggleClass: 'activePin',
//       pin: true,
//       scrub: 1,
//     //   {% comment %} markers: true, {% endcomment %}
//       pinSpacing: true,
//       onUpdate: (self) => {
//         let progress = self.progress;
//         gsap.to('.opacity_s', { opacity: progress });
//       },
//     });
//   }); 

//  gsap.set(pinGroupsImage, {
//     opacity: 0,
//     y: 100
//   });

//   const enterConfig = { y: 0, opacity: 1, duration: 0.4 };

//   pinGroupsImage.forEach((e, i) => {
//     ScrollTrigger.create({
//       trigger: e,
//       start: 'top 40%',
//       onEnter: () => gsap.to(e, enterConfig),
//       onEnterBack: () => gsap.to(e, enterConfig),
//       onLeave: () => gsap.to(e, { y: -50, opacity: 0, duration: 0.4 }),
//       onLeaveBack: () => gsap.to(e, { y: 100, opacity: 0, duration: 0.4 }),
//       scrub: 1,
//       markers: true,
//     });
//   });
